<div class="hierarchy-selection-container" [ngStyle]="{'max-height': fixedHeight ? '600px' : 'none'}">
  <button type="button" class="close close-hierarchy-btn" (click)="closeHierarchy()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
  </button>
  <p class="hierarchy-title">Browse <span style="text-transform: lowercase;">{{propertyDisplay}}</span></p>
  <p class="hierarchy-desc">Check the <span class="lowercase">{{propertyDisplay}}</span> you want to add. 
    Expand the <span class="lowercase">{{propertyDisplay}}</span> by clicking the arrow. You may select more than one 
    <span class="lowercase">{{propertyDisplay}}</span>.</p>
  <div class="hierarchy-container">
      <app-hierarchy-view [setTreeControl]="treeControl" [treeDataSource]="treeDataSource" [hasChildren]="hasChildren" [hasSearch]="hasSearch"
      [hasCheckbox]="true" (checkedNode)="onCheckedNode($event)" [singleSelection]="singleSelection" [propertyName]="propertyName"
      (expandNode)="onExpandNode($event)" [setVirtualScroll]="false" (searchChanged)="onSearchChanged($event)"></app-hierarchy-view>
    <!-- <div class="row">
      <div class="col-md-3" *ngFor="let row of columnsNumber; index as i; let last = last" style="padding: 0 5px;">
        <div class="col-md-12 hierarchy-box" >
          <ul *ngIf="testObject.length > 0">
            <ng-container *ngIf="testObject[i]">
              <li *ngFor="let prop of testObject[i].ValuesSelection; index as j" [ngClass]="{'hierarchy-items': true, 'hide': !prop.IsSelected, 'active': prop.ShowChild || prop.IsChild}">
                <label for="checkbox_{{i}}{{j}}" class="label-container" [title]="prop.SelectionDisplay">{{prop.SelectionDisplay}}
                    <input id="checkbox_{{i}}{{j}}" type="checkbox" (change)="onChange($event, prop)" [checked]="detailProperty.PropertyValueArray.includes(prop.SelectionValue)"/>
                    <span class="hierarchy-checkmark" ></span>
                </label>
                <a href="javascript:void(0)" [ngClass]="{'hierarchy-expand-btn': true, 'expand': prop.ShowChild, 'hide': last}" (click)="expand($event, i, prop)"></a>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </div> -->
  </div>
</div>